import { Grid } from "@mui/material";
import { FormSection } from "components/FormControls/FormSection";
import { TextInput } from "components/FormControls/TextInput";
import { DateSection } from "components/Layout/Campaign/Common/CampaignBasicSettings/Sections/DateSection";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { DefaultLanguageDataState } from "reduxState/translations/translationsSlice";
import { NameSection } from "./Sections/NameSection";
import { VisibilitySection } from "./Sections/VisibilitySection";

interface Props {
  translations: {
    description?: string;
    locale?: string;
    name?: string;
  }[];
  availableLanguages: DefaultLanguageDataState[];
}

export const BasicSettings = memo(
  ({ translations, availableLanguages }: Props) => {
    const { message } = useMessage();

    return (
      <FormSection title={message({ id: "basicSettings" })}>
        <NameSection
          translations={translations}
          availableLanguages={availableLanguages}
        />
        <DateSection />
        <Grid container spacing={12} mt={0}>
          <Grid xs={12} item>
            <TextInput
              label={message({ id: "referralDisplayOrder" })}
              name="displayOrder"
              type="number"
              width="100%"
              data-test-id="campaign-basic-settings-display-order-input"
            />
          </Grid>
        </Grid>
        <VisibilitySection />
      </FormSection>
    );
  },
);
